
export const ProfileStatusConstants = {
    StatusIdNameNew: "New",
    StatusIdNameApproved: "Approved",
    StatusIdNameLocked: "Locked",

    StatusDisplayNameNew: $localize`Neuregistrierung`,
    StatusDisplayNameApproved: $localize`Genehmigt`,
    StatusDisplayNameLocked: $localize`Gesperrt`
}

export class ProfileStatus {
    public Id: string;
    public DisplayName: string;
}
